.note-error-boundary {
  color: var(--palette-accent-urgent);
  font: use-font-secondary("700 14px/1");
}